'use client'
import React, { useEffect, useState } from 'react'
import Navbar from './Navbar'

const slides = [
  { id: 1, image: 'header1.jpg', alt: 'Slide 1' },
  { id: 2, image: 'header2.jpg', alt: 'Slide 2' },
];

const Header = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <Navbar />

      <div className="relative w-full overflow-hidden">
        <div
          className="flex transition-transform duration-700 ease-in-out"
          style={{ transform: `translateX(-${index * 100}%)` }}
        >
          {slides.map((slide) => (
            <div key={slide.id} className="w-full flex-shrink-0">
              <div className="aspect-[16/9] sm:aspect-[21/9] md:aspect-[24/10] lg:aspect-[25/9]">
                <img
                  src={slide.image}
                  alt={slide.alt}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Header;
